import React from 'react';
import SmartApyCal from '../components/updated/SmartApy/SmartApyCal';

const SmartApyCalPage = () => {
  return (
    <div>
      <SmartApyCal />
    </div>
  );
};

export default SmartApyCalPage;
